import type { FieldMetadataMessageDescriptorDef } from './types';
import { msg } from '@lingui/core/macro';

export const cleanPowerFields = {
  clean_power_contractual_instrument: {
    displayName: msg({
      message: 'Contractual instrument',
      context:
        'The display name for the clean power contractual instrument field',
    }),
  },
  clean_power_percent: {
    displayName: msg({
      message: 'Clean power percentage',
      context: 'The display name for the clean power percent field',
    }),
    externalDescription: msg({
      message:
        'The percentage of energy attributed to clean power coming from the grid.',
      context: 'Clean power percent',
    }),
  },
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;

export const onsiteCleanPowerFields = {
  onsite_clean_fuel_kind: {
    displayName: msg({
      message: 'Onsite clean fuel kind',
      context: 'The display name for the onsite clean fuel kind field.',
    }),
  },
  onsite_clean_power_percent: {
    displayName: msg({
      message: 'Onsite clean power percent',
      context: 'The display name for the onsite clean power percent field',
    }),
    externalDescription: msg({
      message:
        'The percentage of energy generated from renewable sources onsite',
      context: 'Onsite clean power percent',
    }),
  },
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;

export const allCleanPowerFields = {
  ...cleanPowerFields,
  ...onsiteCleanPowerFields,
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;
